const env = window.location.hostname.toLowerCase().split( '.' ).find( function ( chunk ) {
    return [ 'ci', 'dev', 'qa', 'pprd', 'localhost' ].indexOf( chunk ) >= 0;
} );

function getURL( url ) {
	return url.toLowerCase().replace( '(env.)', env ? ( env === 'localhost' ? 'qa.' : env + '.' ) : '' );
}

// services
export const idURL = getURL( 'https://(env.)api.biw.cloud/v1/id' );
export const cmxURL = getURL( 'https://(env.)api.biw.cloud/v2/cmx' );
export const navigationURL = getURL( 'https://(env.)api.biw.cloud/v1/navigation' );
export const navigationURLv2 = getURL( 'https://(env.)api.biw.cloud/v2/navigation' );
export const permissionsURL = getURL( 'https://(env.)api.biw.cloud/v1/permissions-manager' );

// hatches
export const TRANSLATIONS_EDITOR_HATCH_URL = getURL( 'https://(env.)translations-editor-hatch.biw.cloud' );
export const rosterGroupsHatchURL = getURL( 'https://(env.)roster-groups.biw.cloud' );